import React from 'react';
import { Link } from 'react-router-dom';
import BarometreLogo from './BarometreLogo';

const linkClass =
  'text-slate-600 hover:text-primary-600 py-2 min-h-[44px] inline-flex items-center rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2';

const headingClass = 'text-xs font-semibold uppercase tracking-wider text-slate-500 mb-3';

export default function PublicFooter() {
  return (
    <footer className="border-t border-slate-200 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 sm:py-12">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-12 lg:gap-8">
          {/* Marque */}
          <div className="lg:col-span-4 flex flex-col items-start gap-4">
            <Link
              to="/"
              className="group flex items-center gap-3 min-h-[44px] rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2"
            >
              <BarometreLogo
                decorative
                className="h-11 w-11 text-primary-600 transition-transform group-hover:scale-105"
              />
              <span className="text-left">
                <span className="block font-bold text-slate-900 text-base leading-tight group-hover:text-primary-700">
                  Baromètre Social
                </span>
                <span className="block text-xs font-medium text-primary-600">Temps réel</span>
              </span>
            </Link>
            <p className="text-sm text-slate-600 max-w-xs leading-relaxed">
              Mesurez le climat social, anticipez les tensions — micro-sondages anonymes en
              quelques secondes.
            </p>
          </div>

          {/* Navigation */}
          <nav className="lg:col-span-2" aria-label="Liens du pied de page">
            <h2 className={headingClass}>Navigation</h2>
            <ul className="flex flex-col gap-0.5">
              <li>
                <Link to="/pricing" className={linkClass}>
                  Tarifs
                </Link>
              </li>
              <li>
                <Link to="/register" className={linkClass}>
                  Inscription
                </Link>
              </li>
              <li>
                <Link to="/login" className={linkClass}>
                  Connexion
                </Link>
              </li>
            </ul>
          </nav>

          {/* Légal */}
          <nav className="lg:col-span-3" aria-label="Informations légales">
            <h2 className={headingClass}>Légal</h2>
            <ul className="flex flex-col gap-0.5">
              <li>
                <Link to="/mentions-legales" className={linkClass}>
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link to="/politique-confidentialite" className={linkClass}>
                  Politique de confidentialité
                </Link>
              </li>
              <li>
                <Link to="/cgu" className={linkClass}>
                  Conditions d&apos;utilisation
                </Link>
              </li>
            </ul>
          </nav>

          {/* Crédits / éditeurs */}
          <div className="lg:col-span-3">
            <h2 className={headingClass}>Éditeurs de l&apos;application</h2>
            <p className="text-sm text-slate-600 mb-4 leading-relaxed">
              Une réalisation du{' '}
              <a
                href="https://www.webmonster.tech"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-600 font-medium underline-offset-2 hover:text-primary-700 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 rounded"
              >
                Collectif Webmonster
              </a>{' '}
              et de{' '}
              <a
                href="https://www.numera11y.fr"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-600 font-medium underline-offset-2 hover:text-primary-700 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 rounded"
              >
                numera11y
              </a>
              .
            </p>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-slate-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 text-xs text-slate-500">
          <p>
            © {new Date().getFullYear()} Baromètre Social Temps Réel. Tous droits réservés.
          </p>
          <p className="sm:text-right max-w-md">
            Les liens externes s&apos;ouvrent dans un nouvel onglet ; les éditeurs demeurent
            responsables de leurs sites respectifs.
          </p>
        </div>
      </div>
    </footer>
  );
}
